module.exports = __webpack_public_path__ + "static/media/premian.35dc8f61.jpg";